export default "__VITE_ASSET__CiS1jZlr__"